/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Currency } from './Currency';
import { TaxBehavior } from './TaxBehavior';
const BasePriceParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['currency', Currency],
    ['amount', parsers.decimal],
    ['refundPeriod', parsers.duration, 'refund_period'],
    ['taxBehavior', TaxBehavior, 'tax_behavior'],
]);
export class BasePrice extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BasePriceParser.decode(input).map(res => new BasePrice(res));
    }
    static unsafeDecode(input) {
        return BasePrice.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BasePriceParser.encode(data);
    }
    static schema() {
        return BasePriceParser.schema();
    }
}
